export default "__VITE_ASSET__a31d7812__"